import { orgChartData } from './data/orgChartData';
import React, { useState } from 'react';
import OrganizationChart from './OrganizationChart';
import './App.css';
import SearchBar from './searchbar';

const App = () => {
  const [departmentVisibility, setDepartmentVisibility] = useState({});
  const [searchResults, setSearchResults] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [hasResults, setHasResults] = useState(true); // New state to track if search has results

  const toggleDepartmentVisibility = (departmentName) => {
    setDepartmentVisibility((prevVisibility) => ({
      ...prevVisibility,
      [departmentName]: !prevVisibility[departmentName],
    }));
  };

  const handleSearch = (query) => {
    if (query.trim() === '') {
      setShowModal(false);
      setHasResults(true); // Reset the hasResults flag
      return;
    }

    // Flatten the array of employees from all departments
    const allEmployees = orgChartData.organization.departments
      .flatMap(dept => dept.employees);

    // Filter employees based on the search query
    const results = allEmployees.filter(employee =>
      employee.name.toLowerCase().includes(query.toLowerCase())
    );

    setSearchResults(results);
    setHasResults(results.length > 0); // Update hasResults based on the search outcome
    setShowModal(true);
  };

  const renderSearchModal = () => {
    return showModal && (
      <div className="search-modal">
        {searchResults.map((employee) => (
          <div key={employee.name} className="search-result">
            <h4>{employee.name}</h4>
            <p>Department: {employee.department}</p>
            <p>Salary: ${employee.salary}</p>
            <p>Office: {employee.office}</p>
            <p>Skills: {employee.skills.join(', ')}</p>
          </div>
        ))}
        {!hasResults && <p>No employee was located with that name.</p>}
      </div>
    );
  };

  return (
    <div className="App">
      <header className="App-header">
        {"This shows the entire organizationChart alongside with plus/minus signs to help expand and minimize the view. In addition you can also search for certain employees to find their pertinent information."}
      </header>
      <div className="App-content">
        <OrganizationChart
          data={orgChartData.organization}
          departmentVisibility={departmentVisibility}
          toggleDepartmentVisibility={toggleDepartmentVisibility}
        />
        <SearchBar onSearch={handleSearch} hasResults={hasResults} />
        {renderSearchModal()}
      </div>
    </div>
  );
};

export default App;
